import { ROUTES } from "@/constants/Routes"
import { ATTRIBUTION_NAMES } from "@/constants/User"
import { hasAttribution } from "@/utils/permissions"
import { useUserStore } from "@/store/useUserStore"
import { Alert, Box, Link, Typography } from "@mui/material"
import Image from "next/image"
import eps_example from "@/assets/images/eps_example.png"

export function EPSManagement() {
  const canManage = useUserStore(
    ({ attributions, isAdmin }) =>
      hasAttribution(attributions ?? [], ATTRIBUTION_NAMES.ETICO) || isAdmin,
  )

  return (
    <>
      <Alert severity="warning">
        Somente administradores e especialistas éticos podem gerenciar EPS
      </Alert>

      <Typography variant="body2">
        Conforme metologia RAIES, pode haver somente uma EPS no sistema.
        Portanto, uma vez cadastrada é possível somente{" "}
        {canManage ? <Link href={ROUTES.EPS.EDIT}>editar</Link> : "editar"} os
        dados da mesma.
      </Typography>

      <Typography variant="body2">
        O{" "}
        {canManage ? (
          <Link href={ROUTES.EPS.REGISTER}>cadastro de uma EPS</Link>
        ) : (
          "cadastro de uma EPS"
        )}{" "}
        <span style={{ fontWeight: "bold" }}>não</span> requer a aprovação do
        Comitê de Avaliação. Portanto, ao cadastrar a EPS, já é possível
        cadastrar{" "}
        {canManage ? (
          <Link href={ROUTES.QUESTIONNAIRE.REGISTER.EPS}>
            novos questionários
          </Link>
        ) : (
          "novos questionários"
        )}
        .
      </Typography>

      <Box>
        <Image
          loading="lazy"
          width={480}
          placeholder="blur"
          src={eps_example}
          alt="exemplo de AIA"
          style={{ borderRadius: "0.25rem" }}
        />
        <Typography component={"p"} variant="caption" sx={{ paddingLeft: 0.5 }}>
          Exemplo de EPS com descrição associada e um questionário publicado
        </Typography>
      </Box>

      <Typography variant="body2">
        Diferentemente das AIAs, a EPS não contém perguntas de enquadramento,
        pois conforme a metodologia RAIES, a EPS é obrigatória.
      </Typography>

      <Box>
        <Typography variant="body2">
          A EPS é composta pelas seguintes propriedades:
        </Typography>
        <ul
          style={{
            margin: 0,
            paddingLeft: "1.5rem",
            paddingTop: "0.2rem",
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <li>
            <Typography variant="body2">Título</Typography>
          </li>
          <li>
            <Typography variant="body2">Descrição</Typography>
          </li>
        </ul>
      </Box>

      <Typography variant="body2">
        Alterar os dados da EPS não impacta nos questionários que estão
        vinculados a ela. Exceto os questionários, os dados passíveis de{" "}
        {canManage ? <Link href={ROUTES.EPS.EDIT}>edição</Link> : "edição"} são
        os mesmos que a compõem.
      </Typography>
    </>
  )
}
